<template>
  <div>
    <!-- loading -->
    <div>
      <div
        class="col-md-6 my-2"
        v-if="hasPermissions('superAdmin') && userSelectedIsBdrUser"
      >
        <h5 class="my-2 font-weight-bold text-center">Fix Salary</h5>
        <input
          type="number"
          v-model="selected.user.fixed_salary"
          class="form-control"
          :disabled="true"
          min="1"
        />
        <hr />
        <h5 class="my-2 font-weight-bold text-center"> {{ $t("lang.column.header_booker_commission") }}</h5>
        <input
          type="number"
          v-model="selected.user.commission_meeting"
          class="form-control"
          :disabled="true"
          min="1"
        />
        <hr />
      </div>
      <div class="row" v-if="userSelectedIsBdrUser">
        <div class="col-md-6">
          <h4 class="text-center">
            {{ $t("lang.column.bank_details") }}
          </h4>
          <div class="card py-2" v-if="selected.user.bank_data">
            <div class="px-4">
              <div>
                <label for="YourEmail" class="h6">
                  {{ $t("lang.column.name") }} :
                  {{ selected.user.bank_data.account_holder_name }}
                </label>
              </div>

              <div>
                <label for="YourEmail" class="h6">
                  {{ $t("lang.column.date_birth") }} :
                  {{ selected.user.date_of_birth }}
                </label>
              </div>

              <div>
                <label for="YourEmail" class="h6">
                  RIB :
                  {{ selected.user.bank_data.rib }}
                </label>
              </div>

              <div>
                <label for="YourEmail" class="h6">
                  BIC :
                  {{ selected.user.bank_data.bic }}
                </label>
              </div>

              <div>
                <label for="YourEmail" class="h6">
                  {{ $t("lang.column.address") }} :
                  {{ selected.user.bank_data.address }}
                </label>
              </div>

              <div>
                <label for="YourEmail" class="h6">
                  {{ $t("lang.label.postalcode") }} :
                  {{ selected.user.bank_data.postal_code }}
                </label>
              </div>

              <div>
                <label for="YourEmail" class="h6">
                  {{ $t("lang.column.city") }} :
                  {{ selected.user.bank_data.city }}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- select saved bank -->
      <div class="row my-2" v-if="userSelectedIsBdrUser">
        <div class="col-md-6">
          <h5 class="text-center">Saved bank details</h5>
          <select
            v-model="selected.user.saved_bank_detail"
            class="form-control"
          >
            <option value="1">Yes</option>
            <option value="0">No</option>
            <option value="2">Bad data</option>
          </select>
          <hr />
        </div>
      </div>

      <div class="col-md-12">
        <button
          @click="saveUserPaymentDetail()"
          class="btn btn-primary w-25 font-weight-bold rounded-pill"
        >
          {{ $t("lang.button.update") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { usersService, bookersService } from "@/_services";
export default {
  props: {
    selected: {
      type: Object,
    },
    selectedUserId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {};
  },
  computed: {
    userSelectedIsBdrUser() {
      return this.selected.user.team_role_id == 2 &&
        this.selected.user.role_id == 2
        ? true
        : false;
    },
  },
  methods: {
    hasPermissions(perm) {
      return this.$store.getters["authentication/hasPermissions"](perm);
    },
    saveUserPaymentDetail() {
      bookersService.saveUserPaymentDetail(this.selectedUserId, this.selected.user.saved_bank_detail).then((res) => {
        this.$swal({
          type: "success",
          title: this.$t("lang.label.great"),
          text: this.$t("lang.label.datasavedsuccessfully"),
          showConfirmButton: false,
          timer: 5000,
        });
      }).then(() => {
        this.$emit("getUser");
      })
    },
  },
};
</script>
